import React from "react";
import "./Techstacks.css";
import { FaReact, FaJava, FaPython, FaDocker } from "react-icons/fa";
import { DiCss3, DiMongodb } from "react-icons/di";
import { VscGithub } from "react-icons/vsc";
import { BsBootstrap } from "react-icons/bs";
import { SiHtml5, SiFlutter, SiMysql, SiFlask } from 'react-icons/si';
export const Techstacks = () => {
  return (
    <>
      <div className="section main" data-aos="fade-right">
        <h2 className="section__title different">Skills</h2>
        <div className="techsection">

          <div>
            <FaPython />
            <h5>Python</h5>
          </div>

          <div>
            <FaJava />
            <h5>Java</h5>
          </div>
          <div>
            <SiFlutter />
            <h5>Flutter</h5>
          </div>
          <div>
            <SiMysql />
            <h5>MySQL</h5>
          </div>
          <div>
            <DiMongodb />
            <h5>MongoDb</h5>
          </div>

          <div>
            <SiFlask />
            <h5>Flask</h5>
          </div>
          <div>
            <FaDocker />
            <h5>Docker</h5>
          </div>
          <div>
            <VscGithub />
            <h5>Github</h5>
          </div>
          <div>
            <SiHtml5 />
            <h5>HTML</h5>
          </div>
          <div>
            <DiCss3 />
            <h5>CSS</h5>
          </div>
          <div>
            <BsBootstrap />
            <h5>Bootstrap</h5>
          </div>
          <div>
            <FaReact />
            <h5>React</h5>
          </div>
        </div>
      </div>
    </>
  );
};
